import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import ProductListItems from './ProductListItems';
import { AppState } from '../../../../store';
import { onGetAllProducts } from '../../../../store/actions/productActions';
import Bazzskelton from '../../../../common/BazzSkelton';

export default function Products(props: any) {
	const dispatch = useDispatch();
	
	const { products } = useSelector<AppState, AppState['products']>(
		({ products }) => products,
	);
	const { loading } = useSelector<AppState, AppState['common']>(
		({ common }) => common,
	);

	useEffect(() => {
		dispatch(onGetAllProducts({
			pageNumber: '',
			seller: '',
			name: '',
			category: props.selectedCategory || '',
			subcategory: props.selectedSubCategory || '',
			order: '',
			min: 0,
			max: 0,
			rating: 0
		}))
	}, [dispatch, props])

	const productList = products && products.products ? products.products : null
	return (
		<Box p={1} width="100%">
			<Box component="h5" mb={0} m={1}>Featured Products</Box>
			{/* Loading */}
			{loading && <Bazzskelton list={[1,2,3,4,5,6]} />}
			{/* No product found! */}
			{!loading && (!productList || productList.length === 0) && <Box textAlign="center">No Results Found!</Box>}
			{/* Products list */}
			{!loading && productList && productList.length > 0 &&
				<ProductListItems products={productList} />
			}
		</Box>
	);
}
